import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

export type BatchDeletionImpact = components["schemas"]["BatchDeletionImpactResponse"];

export const DELETION_IMPACT_QUERY_KEY = ["import-deletion-impact"] as const;

/**
 * The pre-delete preview for one import batch (file metadata + present/modified
 * trade counts + net removed under each toggle state). Disabled until a job id is
 * set, so opening the delete dialog triggers the fetch and closing it idles.
 */
export function useDeletionImpact(jobId: string | null) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...DELETION_IMPACT_QUERY_KEY, jobId],
    enabled: jobId !== null,
    queryFn: async () => {
      const { data, error } = await client.GET(
        "/api/imports/jobs/{job_id}/deletion-impact",
        { params: { path: { job_id: jobId as string } } },
      );
      if (error !== undefined) {
        throw new Error("Failed to load deletion impact");
      }
      return data;
    },
  });
}
